<style scoped lang="scss">
.container {
    height: 100vh;
    display: flex;
    margin: 0;
    flex-direction: column;
    position: relative;
}

.main-content1 {
    overflow-y: auto;
    padding: 7rem 1rem 1rem 1rem;
    max-height: calc(100vh - 6rem);
}

.about-section {
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem 1rem;
}

.about-header {
    text-align: center;
    margin-bottom: 4rem;
    
    h1 {
        font-size: 2.5rem;
        font-weight: 700;
        color: #1f2937;
        margin-bottom: 1.5rem;
        line-height: 1.2;
    }
    
    p {
        font-size: 1.125rem;
        color: #4b5563;
        max-width: 800px;
        margin: 0 auto;
        line-height: 1.7;
    }
}

.about-image {
    width: 100%;
    max-width: 800px;
    height: auto;
    border-radius: 1rem;
    margin: 2rem auto;
    display: block;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.partners-section {
    background-color: #f9fafb;
    padding: 4rem 1rem;
    margin: 4rem 0;
    
    h2 {
        font-size: 2rem;
        font-weight: 600;
        color: #1f2937;
        text-align: center;
        margin-bottom: 1.5rem;
    }
    
    p {
        text-align: center;
        color: #4b5563;
        max-width: 800px;
        margin: 0 auto 3rem;
        line-height: 1.7;
    }
}

.partners-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 2rem;
    max-width: 1000px;
    margin: 0 auto;
    align-items: center;
    justify-items: center;
    
    img {
        height: auto;
        filter: grayscale(30%);
        transition: filter 0.3s ease;
        
        &:hover {
            filter: grayscale(0%);
        }
    }
}

.mission-section {
    padding: 4rem 1rem;
    
    h2 {
        font-size: 2rem;
        font-weight: 600;
        color: #1f2937;
        margin-bottom: 1.5rem;
    }
    
    p {
        color: #4b5563;
        line-height: 1.7;
        margin-bottom: 1.5rem;
    }
}

.mission-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
    margin-top: 3rem;
    
    .main-image {
        grid-column: 1;
        grid-row: 1 / span 2;
        
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 1rem;
        }
    }
    
    .sub-images {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 1rem;
        
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 0.5rem;
        }
    }
}

@media (max-width: 768px) {
    .about-header {
        h1 {
            font-size: 2rem;
        }
        
        p {
            font-size: 1rem;
        }
    }
    
    .mission-grid {
        grid-template-columns: 1fr;
        
        .main-image {
            grid-column: 1;
            grid-row: 1;
        }
    }
    
    .partners-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

/* 设置滚动条样式 */
::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

::-webkit-scrollbar-track {
    background: transparent;
}

::-webkit-scrollbar-thumb {
    background: rgba(156, 163, 175, 0.3);
    border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
    background: rgba(156, 163, 175, 0.5);
}

/* 火狐浏览器滚动条样式 */
* {
    scrollbar-width: thin;
    scrollbar-color: rgba(156, 163, 175, 0.3) transparent;
}
</style>
<template>
    <div class="container" id="__nuxt">
        <div style="display: flex;flex-direction: column;height: 100%;">
            <IndexHeader />
            <div class="main-content1">
                <div class="about-section">
                    <div class="about-header">
                        <h2 style="font-size: 2rem;font-weight: 700;">本站由晓风个人全栈开发运营，晓风致力于为每一个顾客提供最优质的服务。</h2>
                        <p>晓风云科技的核心业务主要涉及软件程序、企业通信、云服务器等领域的研发和应用。具体来说，本公司开展软件研发、网页在线客服、软件授权解决方案的实施等相关业务。</p>
                    </div>
                    <img src="/img/about1.jpg" class="about-image" alt="关于我们">
                </div>

                <div class="partners-section">
                    <h2>我的合作伙伴</h2>
                    <p>合作伙伴与本站携手创造未来，携手发展信息时代，营造一个美好的互联网时代，制作出更符合人心的应用产品，走向新的未来</p>
                    <div class="partners-grid">
                        <img style="width: 90vw;" src="/img/index_case_logos1.png" alt="合作伙伴">
                    </div>
                </div>

                <div class="mission-section">
                    <h2>我的使命</h2>
                    <p>晓风云科技的愿景和使命是利用先进的技术和创新的解决方案，推动数字化转型，为客户提供高效、可靠的应用验证和新型官网程序，帮助他们实现业务增长和创新。</p>
                    <p>晓风云科技以创新为核心，不断推动技术前沿的探索和应用，为客户提供高质量的产品和服务。</p>
                    <div class="mission-grid">
                        <div class="main-image">
                            <img src="/img/about2.jpg" alt="使命图片1">
                        </div>
                        <div class="sub-images">
                            <img src="/img/about3.jpg" alt="使命图片2">
                            <img src="/img/about4.jpg" alt="使命图片3">
                            <img src="/img/about5.jpg" alt="使命图片4">
                        </div>
                    </div>
                </div>
            </div>
            <IndexFooter />
        </div>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
import IndexHeader from '@/components/IndexHeader.vue'
import IndexFooter from '@/components/IndexFooter.vue'


export default defineComponent({
    name: 'AboutView',
    components: {
        IndexHeader,
        IndexFooter
    },
    data() {
        return {
        }
    },
    computed: {
    },
    methods: {
    },
})
</script>